import { UserAgreementAcceptGaurd } from '../service/common/user-agreement-acceptguard.service';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MainPageSaveGuard } from './main-page-saveguard.service';
import { MainPageComponent } from './main-page.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { CarinaUIModule } from '@hilti/carina-ui';
import { CommonModule } from '@angular/common';
import { StpConfigureComponent } from './stp-configure/stp-configure.component';
import { FileUploadModule } from 'ng2-file-upload';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConnectorManagmentComponent } from './master-data/connectors/connector-managment/connector-managment.component';
import { ConnectorGridComponent } from './master-data/connectors/connector-grid/connector-grid.component';
import { CrossSectionGridComponent } from './master-data/cross-sections/cross-sections-grid/cross-sections-grid.component';
import { CrossSectionManagmentComponent } from './master-data/cross-sections/cross-sections-managment/cross-sections-managment.component';
import { ChannelsGridComponent } from './master-data/channels/channels-grid/channels-grid.component';
import { ChannelsManagmentComponent } from './master-data/channels/channels-managment/channels-managment.component';
import { SelectModule } from 'ng2-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SystemsGridComponent } from './dictionaries/systems-grid/systems-grid.component';
import { CorosionProtectionGridComponent } from './dictionaries/corosion-protections-grid/corosion-protections-grid.component';
import { DesignBasesGridComponent } from './dictionaries/design-bases-grid/design-bases-grid.component';
import { SubcomponentsVerificationGridComponent } from './dictionaries/subcomponents-verification-grid/subcomponents-verification-grid.component';
import { InteractionEquationsComponent } from './dictionaries/interaction-equations-grid/interaction-equations-grid.component';
import { KatexModule } from 'ng-katex';
import { ReleasesComponent } from './dictionaries/releases-grid/releases-grid.component';
import { ArmsConfigureComponent } from './stp-configure/arms-configure/arms-configure.component';
import { OrientationPositioningComponent } from './stp-configure/orientation-positioning/orientation-positioning.component';
import { ProfilesConfigureComponent } from './stp-configure/profiles-configure/profiles-configure.component';
import { ReleaseSelectComponent } from '../shared/release-select/release-select.component';
import { BasesGridComponent } from '../main-page/master-data/bases/bases-grid/bases-grid.component';
import { BasesManagmentComponent } from '../main-page/master-data/bases/bases-managment/bases-managment.component';
import { DisableControlDirective } from '../shared/directives/disableFormsControl';
import { PartListComponent } from './stp-configure/part-list/part-list.component';
import { VariantVerificationGridComponent } from '../shared/variant-verification-grid/variant-verification-grid.component';
import { MaterialsGridComponent } from './dictionaries/materials-grid/materials-grid.component';
import { PiperingGroupsGridComponent } from './dictionaries/pipering-groups-grid/pipering-groups-grid.component';
import { PipeRingsGridComponent } from './master-data/pipe-rings/pipe-rings-grid/pipe-rings-grid.component';
import { PipeRingsManagmentComponent } from './master-data/pipe-rings/pipe-rings-managment/pipe-rings-managment.component';
import { PiperingConfigureComponent } from '../main-page/stp-configure/pipering-configure/pipering-configure.component';
import { ThreadedConfigureComponent } from '../main-page/stp-configure/threaded-configure/threaded-configure.component';
import { PipeFunctionsGridComponent } from './dictionaries/pipe-functions-grid/pipe-functions-grid.component';
import { PipeGroupsGridComponent } from '../main-page/dictionaries/pipe-groups-grid/pipe-groups-grid.component';
import { PipeMaterialsGridComponent } from './dictionaries/pipe-material/pipe-materials-grid/pipe-materials-grid.component';
import { PipeMaterialManagmentComponent } from './dictionaries/pipe-material/pipe-material-managment/pipe-material-managment.component';
import { HttpClientModule, HttpClient} from '@angular/common/http';
import { InsulationMaterialsGridComponent } from './dictionaries/insulation-material/insulation-materials-grid/insulation-materials-grid.component';
import { InsulationMaterialManagmentComponent } from './dictionaries/insulation-material/insulation-material-managment/insulation-material-managment.component';
import { PipeMaterialTypesGridComponent } from '../main-page/dictionaries/pipe-material-types-grid/pipe-material-types-grid.component';
import { PipeToPiperingsGridComponent } from './settings/pipe-to-piperings/pipe-to-piperings-grid/pipe-to-piperings-grid.component';
import { PipeToPiperingsManagmentComponent } from './settings/pipe-to-piperings/pipe-to-piperings-managment/pipe-to-piperings-managment.component';
import { PipesGridComponent } from '../main-page/master-data/pipes/pipes-grid/pipes-grid.component';
import { PipesManagmentComponent } from '../main-page/master-data/pipes/pipes-managment/pipes-managment.component';
import { PiperingBossesGridComponent } from '../main-page/master-data/pipering-bosses/pipering-bosses-grid/pipering-bosses-grid.component';
import { PiperingBossesManagementComponent } from '../main-page/master-data/pipering-bosses/pipering-bosses-managment/pipering-bosses-managment.component';
import { PipeFasteningsGridComponent } from './master-data/pipe-fastening/pipe-fastening-grid/pipe-fastening-grid.component';
import { PipeFasteningsManagmentComponent } from './master-data/pipe-fastening/pipe-fastening-managment/pipe-fastening-managment.component';
import { OrderByNamePipe } from '../shared/pipes/sort-pipe';
import { PipeFasteningGroupsGridComponent } from './dictionaries/pipe-fastening-groups-grid/pipe-fastening-groups-grid.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { GridModule } from '@progress/kendo-angular-grid';
import { PiperingFamiliesGridComponent } from './dictionaries/pipering-families/pipering-families-grid/pipering-families-grid.component';
import { PiperingFamilyManagmentComponent } from './dictionaries/pipering-families/pipering-family-managment/pipering-family-managment.component';




export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  imports: [
    CarinaUIModule,
    CommonModule,
    FileUploadModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    NgbModule,
    KatexModule,
    GridModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
      provide: TranslateLoader,
      useFactory: (createTranslateLoader),
      deps: [HttpClient]
      }
    }),
  ],
  declarations: [
    MainPageComponent,
    SideMenuComponent,
    ConnectorGridComponent,
    ConnectorManagmentComponent,
    BasesGridComponent,
    BasesManagmentComponent,
    PipeFasteningsGridComponent,
    PipeFasteningsManagmentComponent,
    CrossSectionGridComponent,
    CrossSectionManagmentComponent,
    ChannelsGridComponent,
    ChannelsManagmentComponent,
    PipeRingsGridComponent,
    PipeRingsManagmentComponent,
    SystemsGridComponent,
    PiperingGroupsGridComponent,
    CorosionProtectionGridComponent,
    DesignBasesGridComponent,
    SubcomponentsVerificationGridComponent,
    OrientationPositioningComponent,
    InteractionEquationsComponent,
    PipeFunctionsGridComponent,
    PipeGroupsGridComponent,
    PipeFasteningGroupsGridComponent,
    PipeMaterialsGridComponent,
    PipeMaterialTypesGridComponent,
    PipeMaterialManagmentComponent,
    InsulationMaterialsGridComponent,
    InsulationMaterialManagmentComponent,
    PipesGridComponent,
    PipesManagmentComponent,
    PiperingBossesGridComponent,
    PiperingBossesManagementComponent,
    ReleasesComponent,
    StpConfigureComponent,
    ArmsConfigureComponent,
    ProfilesConfigureComponent,
    PiperingConfigureComponent,
    ThreadedConfigureComponent,
    ReleaseSelectComponent,
    VariantVerificationGridComponent,
    MaterialsGridComponent,
    PipeToPiperingsGridComponent,
    PipeToPiperingsManagmentComponent,
    PiperingFamiliesGridComponent,
    PiperingFamilyManagmentComponent,
    DisableControlDirective,
    OrderByNamePipe,
    PartListComponent
  ],
  exports : [
    DisableControlDirective,
    TranslateModule
  ],
  providers: [
    MainPageSaveGuard,
    UserAgreementAcceptGaurd
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MainPageModule { }
